import { render } from "./Main.vue?vue&type=template&id=f9c8866c"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=f9c8866c&lang=css"

import exportComponent from "D:\\koreit_site\\06.Sites\\www.koreit.co.kr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__